/**
 * crazxy-slideshow-fix.js
 *
 * Fallback for Android WebView in case slideshow.js loads but the
 * IntersectionObserver-based dot tracking still doesn't work.
 * Now that slideshow.js loads on Android WebView, the custom element
 * should upgrade correctly and handle most cases natively.
 * This file stays as a safety net only.
 */
(function () {
  if (!window.__czxIAB) return;

  var DEBOUNCE_MS = 80;

  function computeIndex(scroller, slides) {
    var scrollLeft = scroller.scrollLeft;
    var width = scroller.offsetWidth;
    if (!width || !slides.length) return 0;
    var best = 0, bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var dist = Math.abs(
        (slides[i].offsetLeft + slides[i].offsetWidth / 2) - (scrollLeft + width / 2)
      );
      if (dist < bestDist) { bestDist = dist; best = i; }
    }
    return best;
  }

  function updateDots(slideshow, newIdx) {
    var dots = slideshow.querySelectorAll('[ref="dots[]"], .slideshow-control[aria-selected]');
    dots.forEach(function (dot, i) {
      dot.setAttribute('aria-selected', i === newIdx ? 'true' : 'false');
    });
    var thumbs = slideshow.querySelectorAll('[ref="thumbnails[]"]');
    thumbs.forEach(function (thumb, i) {
      thumb.setAttribute('aria-selected', i === newIdx ? 'true' : 'false');
    });
    var counter = slideshow.querySelector('[ref="current"]');
    if (counter) counter.textContent = String(newIdx + 1);
    var slides = slideshow.querySelectorAll('slideshow-slide');
    var prev = slideshow.querySelector('[ref="previous"]');
    var next = slideshow.querySelector('[ref="next"]');
    if (prev) prev.disabled = newIdx === 0;
    if (next) next.disabled = newIdx === slides.length - 1;
  }

  function patchSlideshow(slideshow) {
    if (slideshow._czxPatched) return;
    slideshow._czxPatched = true;

    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      var scroller = slideshow.querySelector('slideshow-slides');
      if (!scroller) {
        if (attempts >= 30) clearInterval(interval);
        return;
      }
      clearInterval(interval);

      var prevIdx = 0;
      var timer = null;

      scroller.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var slides = Array.prototype.slice.call(
            slideshow.querySelectorAll('slideshow-slide')
          );
          if (!slides.length) return;

          var newIdx = computeIndex(scroller, slides);
          if (newIdx === prevIdx) return;
          prevIdx = newIdx;

          /* If the native custom element isn't upgraded, update dots directly */
          if (typeof slideshow.current !== 'number' || slideshow.current !== newIdx) {
            updateDots(slideshow, newIdx);
            try { slideshow.current = newIdx; } catch(e) {}
          }

          var slide = slides[newIdx];
          if (slide) {
            slideshow.dispatchEvent(new CustomEvent('slideshow:select', {
              bubbles: true,
              detail: {
                index: newIdx, previousIndex: prevIdx,
                userInitiated: true, trigger: 'scroll',
                slide: slide, id: slide.getAttribute('slide-id')
              }
            }));
          }
        }, DEBOUNCE_MS);
      }, { passive: true });
    }, 200);
  }

  function patchAll() {
    document.querySelectorAll('slideshow-component').forEach(patchSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchAll);
  } else {
    patchAll();
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName && n.tagName.toLowerCase() === 'slideshow-component') patchSlideshow(n);
        if (n.querySelectorAll) n.querySelectorAll('slideshow-component').forEach(patchSlideshow);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

})();
